import React, { useEffect } from "react";
import { motion } from "framer-motion";

export const KebijakanPrivasi = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="w-full min-h-screen py-20 text-center text-cyan-600 flex-col justify-center relative bg-gradient-to-b from-slate-50 to-slate-100">
      <div className="container mx-auto px-4">
        <motion.h2
          className="text-base sm:text-lg md:text-xl font-normal uppercase mb-1 md:mb-2 text-cyan-600"
          initial={{ opacity: 0, y: -15 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          viewport={{ once: true }}
        >
          PT VISI EKOSISTEM DIGITAL
        </motion.h2>

        <motion.p
          className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-black mx-auto mb-8 md:mb-16 text-cyan-600 px-4"
          initial={{ opacity: 0, y: -15 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3, ease: "easeInOut" }}
          viewport={{ once: true }}
        >
          KEBIJAKAN PRIVASI
        </motion.p>

        <div className="max-w-5xl mx-auto space-y-4">
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="bg-white rounded-xl px-4 py-6 border border-slate-200">
              <h3 className="text-xl font-bold text-cyan-900 mb-4">
                Kebijakan Privasi
              </h3>
              <div className="text-lg text-cyan-800 space-y-6">
                <p>
                  PT Visi Ekosistem Digital bertindak sebagai pengontrol data
                  pribadi Anda dan menghormati privasi setiap pengguna.
                  Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan,
                  menggunakan, dan melindungi informasi pribadi yang Anda
                  berikan.
                </p>

                <p>
                  Dengan mengakses dan menggunakan website kami di{" "}
                  <a
                    href="https://vionixasia.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-cyan-600 underline"
                  >
                    vionixasia.com
                  </a>
                  , Anda menyetujui ketentuan yang diatur dalam Kebijakan
                  Privasi ini.
                </p>

                <h3 className="text-lg font-semibold text-cyan-700">
                  Informasi yang Kami Kumpulkan
                </h3>
                <p>
                  Kami mengumpulkan informasi secara otomatis saat Anda
                  mengunjungi website, termasuk data perangkat seperti browser,
                  alamat IP, zona waktu, dan cookie. Selain itu, kami
                  mengumpulkan informasi yang Anda berikan secara langsung,
                  seperti nama, alamat email, nomor telepon, dan informasi
                  pembayaran saat melakukan pendaftaran acara.
                </p>

                <h3 className="text-lg font-semibold text-cyan-700">
                  Tujuan Pengumpulan Data
                </h3>
                <p>Data yang kami kumpulkan digunakan untuk:</p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>Memproses pendaftaran acara dan pembayaran.</li>
                  <li>Mengirimkan konfirmasi serta informasi terkait acara.</li>
                  <li>Meningkatkan pengalaman penggunaan website.</li>
                  <li>
                    Menyampaikan pembaruan dan informasi mengenai kegiatan kami.
                  </li>
                </ul>

                <h3 className="text-lg font-semibold text-cyan-700">
                  Hak Anda atas Data Pribadi
                </h3>
                <p>
                  Jika Anda berada di wilayah Eropa atau yurisdiksi lain yang
                  memberikan hak-hak atas data pribadi, Anda memiliki hak untuk
                  mengakses, memperbaiki, menghapus, membatasi, atau menolak
                  pemrosesan data, serta meminta portabilitas data. Permintaan
                  dapat disampaikan melalui kontak kami di bawah.
                </p>

                <h3 className="text-lg font-semibold text-cyan-700">
                  Tautan ke Website Pihak Ketiga
                </h3>
                <p>
                  Website kami dapat memuat tautan ke website lain yang tidak
                  dikelola oleh kami. Kami tidak bertanggung jawab atas
                  kebijakan privasi atau praktik website pihak ketiga tersebut.
                </p>

                <h3 className="text-lg font-semibold text-cyan-700">
                  Keamanan Data
                </h3>
                <p>
                  Kami mengambil langkah-langkah teknis dan administratif yang
                  wajar untuk melindungi data pribadi Anda dari akses yang tidak
                  sah. Namun, kami tidak dapat menjamin sepenuhnya keamanan
                  informasi yang dikirimkan melalui internet.
                </p>

                <h3 className="text-lg font-semibold text-cyan-700">
                  Pengungkapan Informasi
                </h3>
                <p>
                  Kami dapat mengungkapkan informasi pribadi Anda jika
                  diwajibkan oleh hukum, perintah pengadilan, atau untuk
                  melindungi hak, keselamatan, dan keamanan kami maupun pihak
                  lain.
                </p>

                <h3 className="text-lg font-semibold text-cyan-700">Kontak</h3>
                <p>
                  Untuk pertanyaan terkait Kebijakan Privasi ini atau penggunaan
                  data pribadi Anda, silakan hubungi:
                </p>
                <p>
                  PT Visi Ekosistem Digital <br />
                  Email:{" "}
                  <a
                    href="mailto:hello@vionixasia.com"
                    className="text-cyan-800 hover:underline"
                  >
                    hello@vionixasia.com
                  </a>
                  <br />
                  Website:{" "}
                  <a
                    href="https://vionixasia.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-cyan-800 hover:underline"
                  >
                    https://vionixasia.com
                  </a>
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
